import {useEffect} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {CL_RX_METHOD} from 'constants/success';
import {ApplicationStoreType} from 'desktop/store';

import {getIsVerification} from 'libs/success/helpers/helpers';
import {getPopupType} from 'libs/success/prescriptionPopup/prescriptionPopup';
import {getPrescriptionStatusAfterUpdateOrder} from 'libs/success/statuses/statuses';
import {FILL_IT, SUCCESS_PAGE_FIELDS_DEFAULT} from 'types/successPage';

import {useCheckIfExamExists} from '../../../hooks/useCheckIfExamExists';
import {getDrawerState} from '../../../selectorsV2';
import {changeField} from '../../../store/actions/orderItems/orderItems';

import {getOrderItems} from '../../../store/selectors/orderStatus/orderStatus';

import {PropsType} from './contactsItem';

/**
 * Side effects for ContactsItem component
 */
export const useSideEffects = (item: PropsType['item']) => {
    const dispatch = useDispatch();
    const {
        examStatusById,
        isExamByIdExist,
        isFetching: isExamFetching,
    } = useCheckIfExamExists(item.id);
    const hasDoctorDetails = item.hasDoctorDetails && item.prescription?.send_by === FILL_IT;
    const shouldShowButton = !isExamByIdExist && !isExamFetching && !hasDoctorDetails;

    const {id, items, rxMethod} = useSelector((store: ApplicationStoreType) => ({
        id: getDrawerState(store).item?.id,
        items: getOrderItems(store),
        rxMethod: getDrawerState(store).rxMethod,
    }));

    const updatedItemStatus = getPrescriptionStatusAfterUpdateOrder(items, item);
    const isVerification = getIsVerification({
        hasDoctorDetails,
        isExamByIdExist,
        prescriptionMethod: item.prescription?.send_by,
        status: updatedItemStatus,
    });

    const type = getPopupType(item, updatedItemStatus);

    useEffect(() => {
        if (!item || item.id !== id) return;
        dispatch(
            changeField({
                ...SUCCESS_PAGE_FIELDS_DEFAULT,
                fileType: '',
                isEyeExam: rxMethod === CL_RX_METHOD.EYE_EXAM,
                isVisiblyExam: rxMethod === CL_RX_METHOD.EYE_EXAM_ELIGIBILITY,
                orderItemId: String(item.id),
                sendBy: item.prescription?.send_by || 0,
                type: 'success',
            }),
        );
    }, [rxMethod, item, id]);

    return {
        dispatch,
        examStatusById,
        isExamFetching,
        isVerification,
        items,
        shouldShowButton,
        type,
    };
};
